import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-li',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-li{display:block}.mcrai-li--separator{margin-top:5px}`],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class UnorderedListItemComponent implements OnInit {
  @HostBinding('class.mcrai-li') cssClass = true;
  @HostBinding('class.mcrai-li--separator') separatorCssClass = false;
  @HostBinding('class.mcrai-li--highlight') highlightCssClass = false;

  @Input() set separator(value: boolean | null) {
    this.separatorCssClass = value !== false;
  }

  @Input() set highlight(value: boolean | null) {
    this.highlightCssClass = value !== false;
  }

  constructor() { }

  ngOnInit() { }

}
